module.exports = __webpack_public_path__ + "img/symbol_2.3ac8693e.png";